import { terminalSignal } from "@spacecrew/shared";
import type { Snap } from "../net/ship.svelte.js";

/** Terminal signal for the current ship snapshot (1 = pristine). No snapshot = docked and healthy. */
export const screenSignal = (snap: Snap | null): number =>
  snap
    ? terminalSignal({ reserve: snap.reserve, breakerTripped: snap.breakers.status !== "idle", coolantLeak: snap.activeEvent === "coolant", o2: snap.o2, running: snap.phase === "running" })
    : 0.95;
